import HelpPanel from "@amzn/awsui-components-react/polaris/help-panel"

const ToolsPanel = () => (
  <HelpPanel
    header={<h2>Partner List</h2>}
    footer={<p>This page displays a list of all of your Partners onboarded.</p>}
  />
)

export default ToolsPanel
